import React from "react";
import { COLORS } from "styles/colors";
import { HelpGuide } from "hook/useHelpGuideApi";
import { CenterlineText } from "components/atoms/text/Text";
import * as s from "../VideoGuideStyled";
import CHEVRON_LEFT from "assets/icons/chevron_left_slide.svg";
import CHEVRON_RIGHT from "assets/icons/chevron_right_slide.svg";
import ListItemPdf from "./item/ListItemPdf";
import ListItemEtc from "./item/ListItemEtc";
import ListItemYoutube from "./item/ListItemYoutube";
import * as mediaQuery from "components/MediaQuery";

interface VideoGuidesListPresenterProps {
  name: string;
  layout: "slide" | "table";
  handleNextButtonClick: (nextType: "prev" | "next") => void;
  horizontalScrollRef: React.MutableRefObject<HTMLUListElement>;
  onClickGuideItem: (guide: HelpGuide) => void;
  youtubeVideoGuideList: HelpGuide[];
  etcVideoGuideList: HelpGuide[];
}
export default function VideoGuidesListPresenter({
  name,
  layout,
  handleNextButtonClick,
  horizontalScrollRef,
  onClickGuideItem,
  youtubeVideoGuideList = [],
  etcVideoGuideList = [],
}: VideoGuidesListPresenterProps) {
  return (
    <div>
      <CenterlineText color={COLORS.BUTTONS1} bold fontSize={20}>
        {name}
      </CenterlineText>

      {layout === "slide" && (
        <s.VideoDiv>
          <mediaQuery.Default>
            <button
              className="button-left"
              onClick={() => handleNextButtonClick("prev")}
              data-testid="help-video-guides-list-button-next-button"
            >
              <img src={CHEVRON_LEFT} alt="previous" />
            </button>
          </mediaQuery.Default>
          <s.VideoWrapper ref={horizontalScrollRef}>
            {youtubeVideoGuideList.map((guide, index) => (
              <ListItemYoutube
                key={index}
                guide={guide}
                onClickGuideItem={onClickGuideItem}
              />
            ))}
          </s.VideoWrapper>
          <mediaQuery.Default>
            <button
              className="button-right"
              onClick={() => handleNextButtonClick("next")}
              data-testid="help-video-guides-list-button-next-button-2"
            >
              <img src={CHEVRON_RIGHT} alt="next" />
            </button>
          </mediaQuery.Default>
        </s.VideoDiv>
      )}

      {layout === "table" && (
        <s.TableListWrapper>
          <table>
            <tbody>
              {etcVideoGuideList.map((guide, index) => {
                if (
                  guide.resourceType === "pdf" &&
                  (guide.resourceUrl || "").substring(
                    (guide.resourceUrl || "").lastIndexOf(".") + 1
                  ) === "pdf"
                ) {
                  return (
                    <ListItemPdf
                      guide={guide}
                      onClickGuideItem={onClickGuideItem}
                      key={index}
                    />
                  );
                }
                if (
                  guide.resourceType === "etc" ||
                  (guide.resourceUrl || "").substring(
                    (guide.resourceUrl || "").lastIndexOf(".") + 1
                  ) !== "pdf"
                ) {
                  return <ListItemEtc guide={guide} key={index} />;
                }
                return null;
              })}
            </tbody>
          </table>
        </s.TableListWrapper>
      )}
    </div>
  );
}
